import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María C.', 'Juan P.', 'Ana L.', 'Carlos R.', 'Sofía M.', 'Luis G.', 'Elena T.', 'Diego S.', 'Valentina H.', 'Andrés B.'];
const LOCATIONS = ['Buenos Aires, Argentina', 'Santiago, Chile', 'Bogotá, Colombia', 'Lima, Perú', 'CDMX, México', 'Montevideo, Uruguay', 'Córdoba, Argentina', 'Medellín, Colombia', 'Guadalajara, México', 'Quito, Ecuador'];
export const SocialProofPopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    location: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomLocation = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
      setData({
        name: randomName,
        location: randomLocation
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Show for 4 seconds
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Loop
    const interval = setInterval(() => {
      showPopup();
    }, 12000 + Math.random() * 5000); // Random interval between 12-17s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-157">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 bg-white rounded-lg shadow-xl p-4 flex items-center gap-3 border-l-4 border-teal-600 max-w-xs" data-id="element-158">
          <div className="bg-teal-100 p-2 rounded-full" data-id="element-159">
            <CheckCircle className="w-5 h-5 text-teal-600" data-id="element-160" />
          </div>
          <div data-id="element-161">
            <p className="text-sm font-bold text-gray-800" data-id="element-162">
              {data.name} acaba de comprar
            </p>
            <p className="text-xs text-gray-500" data-id="element-163">{data.location}</p>
            <p className="text-xs text-teal-600 font-medium mt-0.5" data-id="element-164">
              MegaPack Ciencias Naturales
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};